module.exports = __webpack_public_path__ + "img/location-deny.d99f0786.png";